import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export interface CampaignUserInfo {
    firstName: string;
    userEmail: string;
}

export function getCampaignUserInfo(): CampaignUserInfo {
    let userConfig = getUserConfiguration();

    let firstName = userConfig.SessionSettings.UserDisplayName;
    const splitted = firstName.split(' ');
    if (splitted && splitted.length > 0) {
        firstName = splitted[0];
    }

    return {
        firstName: firstName,
        userEmail: userConfig.SessionSettings.UserEmailAddress,
    };
}
